import { render } from "./ShopItem.vue?vue&type=template&id=1bdad32f&scoped=true"
import script from "./ShopItem.vue?vue&type=script&lang=js"
export * from "./ShopItem.vue?vue&type=script&lang=js"

import "./ShopItem.vue?vue&type=style&index=0&id=1bdad32f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdad32f"]])

export default __exports__